
import instance from "../axios/axios.config";
const { credential } = instance;

export const getAllusersApi = async () => {
    try {
        const response = await credential.get(`/users`)
        return response?.result || {}
    } catch (error) {
        console.error(error)
    }
}

export const createUserApi = async (payload) => {
    try {
        const response = await credential.post('/users', { ...payload })
        return response?.result
    } catch (error) {
        console.error(error)
    }
}

export const updateUserApi = async (email, payload) => {
    try {
        const response = await credential.put(`/users/${email}`, payload)
        return response
    } catch (error) {
        console.error(error)
    }
}

export const deleteUserApi = async (email) => {
    try {
        const response = await credential.delete(`/users/${email}`)
        return response
    } catch (error) {
        console.error(error)
    }
}

export const getLoggedUserApi = async (email) => {
    try {
        const response = await credential.get(`/users/me?login=${Boolean(email)}`)
        return response
    } catch (error) {
        console.error(error)
    }
}
